<template>
  <!-- 头部整体盒子 -->
  <div id="header" class="container-fuild">
    <!-- <div class="alert alert-danger" role="alert">搜索内容不能为空</div> -->
    <!-- 头部顶部 -->
    <!-- <div class="header-top container-fuild hidden-xs">
      <div class="container">
        <div class="server pull-left">
          <span class="glyphicon glyphicon-earphone"></span>888-888-888
          <span class="glyphicon glyphicon-envelope"></span>liyunkun_11@163.com
          <span class="glyphicon glyphicon-time"></span>7x24小时为您服务
        </div>
        <div class="shejiao pull-right">
          <span class="glyphicon glyphicon-hand-right"></span>赶快联系我们吧！
          <span class="glyphicon glyphicon-hand-left"></span>
        </div>
      </div>
    </div> -->
    <!-- 顶部图标和搜索框 -->
    <div class="logo-search hidden-xs hidden-sm">
      <div class="container">
        <div class="row">
          <div class="logo-search-box">
            <img src="@/assets/img/fh-logo.png" alt="厦门凤凰会展" />
            <div class="logo-title">【凤凰农资节】全国联展</div>
            <input
              class="input-search"
              type="text"
              v-model="keyword"
              @keyup.enter="handleSearch"
              placeholder="请输入搜索的内容"
              @input="handleInput"
            />
            <div
              class="search-btn"
              @click="handleSearch"
              :class="{ active: activeColor }"
            >
              搜索
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 电脑导航 -->
    <div
      class="header-nav container hidden-xs hidden-sm"
      :class="{ is_fixed: isFixed }"
    >
      <!-- 导航logo -->
      <!-- <div class="header-nav-logo">
        <img src="@/assets/img/logo_black.png">
      </div> -->
      <!-- 导航内容 -->
      <ul class="header-nav-wrapper">
        <li
          v-for="(item, index) in navList"
          :key="index"
          :class="index == navIndex ? 'active' : ''"
          @click="navClickOne(index, item.name)"
        >
          <router-link :to="item.path">
            <div class="header-nav-wrapper-item title-algin">
              <img class="header-nav-icon" :src="item.icon" />
              <span class="header-nav-title">{{ item.name }}</span>
              <span
                v-if="item.children.length > 0"
                class="glyphicon glyphicon-menu-down"
              ></span>
              <!-- <i class="underline"></i> -->
            </div>
          </router-link>
          <dl v-if="item.children.length > 0">
            <dt v-for="(i, n) in item.children" :key="n">
              <router-link :to="i.path">{{ i.name }}</router-link>
            </dt>
          </dl>
        </li>
      </ul>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs visible-sm">
      <nav class="navbar navbar-default">
        <div class="container-fluid">
          <!-- Brand and toggle get grouped for better mobile display -->
          <div class="navbar-header">
            <button
              type="button"
              id="btn"
              class="navbar-toggle collapsed"
              data-toggle="collapse"
              data-target="#bs-example-navbar-collapse-1"
              aria-expanded="false"
            >
              <span class="sr-only"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <a class="navbar-brand" href="#">凤凰会展</a>
          </div>

          <!-- Collect the nav links, forms, and other content for toggling -->
          <div
            class="collapse navbar-collapse"
            id="bs-example-navbar-collapse-1"
          >
            <ul class="nav navbar-nav">
              <!-- <li class="active">
                <a href="#">Link <span class="sr-only">(current)</span></a>
              </li>
              <li><a href="#">Link</a></li> -->
              <li
                class="dropdown"
                v-for="(item, index) in navList"
                :key="index"
                @click="navClickTwo(index, item)"
                data-toggle="collapse"
                data-target="#menu"
              >
                <router-link
                  :to="item.path"
                  class="dropdown-toggle"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {{ item.name }}
                  <span class="caret" v-if="item.children.length !== 0"></span>
                  <i class="underline"></i>
                </router-link>
                <ul class="dropdown-menu" v-if="item.children.length !== 0">
                  <li
                    class="dropdown"
                    v-for="(item, index) in item.children"
                    :key="index"
                    @click="navClickThree(index, item)"
                    data-toggle="collapse"
                    data-target="#menu"
                  >
                    <router-link
                      :to="item.path"
                      class="dropdown-toggle"
                      data-toggle="dropdown"
                      role="button"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      {{ item.name }}
                      <i class="underline"></i>
                    </router-link>
                  </li>
                </ul>
              </li>
            </ul>
            <form class="navbar-form navbar-right">
              <div class="form-group">
                <input
                  type="text"
                  v-model="keyword"
                  class="form-control"
                  placeholder="请输入搜索的内容"
                />
              </div>

              <button
                type="submit"
                class="btn btn-primary"
                @click="handleSearch"
              >
                搜索
              </button>
            </form>
          </div>
        </div>
      </nav>
      <!-- 导航栏 -->
      <!-- <div class="header-nav-m-menu text-center">
        <span
          class="glyphicon glyphicon-search search"
          @click="handleSearch"
        ></span>
        {{ menuName }}
        <div
          class="header-nav-m-menu-wrapper"
          data-toggle="collapse"
          data-target="#menu"
          @click="menuClick"
        >
          <span :class="menuClass"></span>
        </div>
      
        <ul id="menu" class="header-nav-m-wrapper collapse">
          <li
            v-for="(item, index) in navList"
            :key="index"
            :class="index == navIndex ? 'active' : ''"
            @click="navClick(index, item.name)"
            data-toggle="collapse"
            data-target="#menu"
          >
            <router-link :to="item.path">
              {{ item.name }}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div> -->
    </div>
  </div>
</template>
<script>
import { enCodeByPhone } from "@/api/api";
import Bus from "@/untils/bus.js";
export default {
  name: "Header",
  data() {
    return {
      navIndex: sessionStorage.getItem("navIndex")
        ? sessionStorage.getItem("navIndex")
        : 0,
      menuName: "凤凰植保会官方网站",
      menuClass: "glyphicon glyphicon-menu-down",
      navList: [],
      //搜索内容
      keyword: "",
      isFixed: false,
      offsetTop: 0,
      activeColor: false,
    };
  },
  created() {
    this.getEnCodeByPhone();
  },
  mounted() {
    window.addEventListener("scroll", this.initHeight);
    this.$nextTick(() => {
      this.offsetTop = document.querySelector("#boxFixed").offsetTop;
    });
  },
  methods: {
    handleInput(e) {
      if (e.data !== "") {
        this.activeColor = true;
      }
    },
    initHeight() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.isFixed = scrollTop > this.offsetTop ? true : false;
    },
    destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
    },
    async getEnCodeByPhone() {
      const res = await enCodeByPhone();
      console.log("qweqweqwe", res);
      if (res.code == 200) {
        this.navList = res.data;
      }
    },
    navClickOne(index, name) {
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = name;
    },
    navClickTwo(index, item) {
      console.log(item);
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = item.name;
      //  console.log('点击触发！');
      if (item.children.length === 0) {
        $("#btn").click();
      }
    },
    navClickThree(index, item) {
      console.log(item);
      this.navIndex = index;
      sessionStorage.setItem("navIndex", index);
      this.menuName = item.name;
      $("#btn").click();
    },
    menuClick() {
      if (this.menuClass == "glyphicon glyphicon-menu-down") {
        this.menuClass = "glyphicon glyphicon-menu-up";
      } else {
        this.menuClass = "glyphicon glyphicon-menu-down";
      }
    },
    // 点击搜索按钮的回调
    handleSearch() {
      console.log("搜索的回调！");
      // this.getArticleSearch(this.keyword)
      if (this.keyword == "") {
        $(".alert").fadeIn("slow");
        setTimeout(() => {
          $(".alert").fadeOut("slow");
        }, 2000);
        return;
      }
      Bus.$emit("search", this.keyword);
      const paths = this.$route.path;

      if (paths === "/plan/search") {
        this.keyword = "";
        return;
      }
      this.$router.push({
        path: "/plan/search",
        query: {
          keyword: this.keyword,
        },
      });
      this.keyword = "";
    },
  },
};
</script>
<style scoped>
.active {
  color: #0076ce !important;
}
/* 顶部 */
#header {
  position: relative;
  background: #f4f4f4;
  transition: all ease 0.6s;
}
.alert {
  width: 200px;
  position: absolute;
  top: 6%;
  left: 50%;
  transform: translateX(-50%);
  z-index: 999;
  text-align: center;
  display: none;
}
#header .header-top {
  height: 50px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #474747;
}
/* 顶部的图标 和搜索框 */
#header .logo-search {
  width: 100%;
  height: 60px;
  color: #fff;
  font-size: 12px;
  line-height: 50px;
  background: #fff;
}
#header .logo-search .logo-search-box {
  position: relative;
}
#header .logo-search .logo-search-box img {
  width: 10%;
  max-height: 210px;
  position: absolute;
  /* left: 9.5%; */
  top: 32%;
  -webkit-transform: translateY(-30%);
  /* transform: translateY(-30%); */
}
#header .logo-search .logo-search-box .logo-title {
  color: #000;
  font-size: 20px;
  margin-left: 130px;
  line-height: 60px;
}
#header .logo-search .logo-search-box .input-search {
  width: 26%;
  height: 38px;
  position: absolute;
  text-indent: 10px;
  color: #0076ce;
  font-weight: 600;
  right: 0;
  top: 50%;
  border-radius: 20px;
  transform: translateY(-50%);
  /* padding-right: 6%; */
}
#header .logo-search .logo-search-box .search-btn {
  color: #4c4948;
  font-size: 0.8vw;
  width: 5%;
  height: 38px;
  position: absolute;
  letter-spacing: 5px;
  top: 50%;
  left: 95%;
  transform: translateY(-66%);
}
#header .logo-search .logo-search-box .search-btn::before {
  content: "";
  width: 1px;
  height: 20px;
  background-color: #474747;
  position: absolute;
  top: 50%;
  left: -8px;
  transform: translateY(-20%);
}
/* #header .header-top span {
  margin: 0 8px;
} */
/* 导航栏 */
.is_fixed {
  position: fixed;
  top: 0;
  z-index: 999;
}
#header .header-nav {
  width: 100%;
  /* height: 70px; */
  background: linear-gradient(90deg, #41b6e6 0%, #0076ce 100%);
  opacity: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* 导航栏logo */
#header .header-nav .header-nav-logo {
  width: 100px;
  height: 100%;
  float: left;
  position: relative;
}
/* 导航栏logo图片 */
#header .header-nav .header-nav-logo img {
  width: 95px;
  height: 45px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
}
/* 导航栏 导航容器 */
#header .header-nav-fixed .header-nav-wrapper {
  line-height: 50px;
}
#header .header-nav .header-nav-wrapper {
  /* line-height: 10px; */
  float: right;
  margin: 0;
  max-width: 1300px;
}
/* 导航栏 每个导航 */
#header .header-nav .header-nav-wrapper > li {
  float: left;
  margin: 0 15px;
  position: relative;
  display: flex;
}

/* 导航栏 每个导航下面的 a 链接 */
#header .header-nav .header-nav-wrapper > li > a {
  color: #fff;
  font-size: 16px;
  font-weight: bold;
  padding: 15px;
  position: relative;
}
/* 导航栏 每个导航的图标 */
/* #header .header-nav .header-nav-wrapper > li img {
  width: 25px;
  height: 25px;
} */
/* 导航栏 每个导航下面的 a 链接的下划线 */
#header .header-nav .header-nav-wrapper > li > a > i {
  display: block;
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  opacity: 0;
  transition: all 0.6s ease;
  background-color: #1e73be;
}
#header .header-nav .header-nav-wrapper .header-nav-icon {
  width: 21.5px;
  height: 20.5px;
  display: inline-block;
  margin-bottom: 6px;
}
#header .header-nav .header-nav-wrapper .header-nav-title {
  margin-left: 2px;
}
/* 导航栏 每个导航下面的 a 链接的右侧小三角 */
#header .header-nav .header-nav-wrapper > li > a > span {
  font-size: 12px;
  transition: transform ease 0.5s;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover {
  /* color: #0076CE; */
  text-decoration: none;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover .underline {
  opacity: 1;
  width: 100%;
  left: 0;
}
/* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
#header .header-nav .header-nav-wrapper > li > a:hover span {
  transform: rotate(180deg);
}
/* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
#header .header-nav .header-nav-wrapper > li.active > a {
  /* color: #1e73be; */
  transform: scale(1.1);
  text-decoration: none;
  border-bottom: 2px solid #fff;
}
/* 导航栏 每个导航下面的二级导航容器 */
#header .header-nav .header-nav-wrapper > li > dl {
  display: none;
  position: absolute;
  width: 168px;
  top: 80%;
  left: 0;
  z-index: 999999;
  box-shadow: 0 0 3px 1px #41b6e6;
  background: linear-gradient(90deg, #41b6e6 0%, #0076ce 100%);
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 */
#header .header-nav .header-nav-wrapper > li > dl > dt {
  width: 100%;
  padding: 10px;
  /* border-bottom: 1px solid #fff; */
  display: flex;
  justify-content: center;
  align-items: center;
}
#header .header-nav .header-nav-wrapper > li > dl > dt > a {
  color: #fff;
}
/* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
#header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
  text-decoration: none;
  color: #1e73be;
}
/* 导航栏 滑上一级导航显示二级导航 */
#header .header-nav .header-nav-wrapper > li:hover dl {
  display: block;
}
#header .header-nav .header-nav-wrapper > li > dl > dt:hover {
  cursor: pointer;
  background-color: rgb(238, 238, 238);
}
/* 媒体查询（平板） */
@media screen and (max-width: 996px) {
  #header .header-nav-m {
    position: relative;
  }
  /* 导航栏  菜单容器 */
  #header .header-nav-m .header-nav-m-menu {
    color: #fff;
    height: 50px;
    font-size: 20px;
    line-height: 50px;
    background: linear-gradient(90deg, #41b6e6 0%, #0076ce 100%);
    position: relative;
  }
  #header .header-nav .header-nav-wrapper {
    line-height: 10px;
    float: right;
    margin: 0;
    max-width: 850px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper > li > a {
    color: #fff;
    font-size: 10px;
    font-weight: bold;
    padding: 10px 0px;
    position: relative;
  }
  /* 导航栏 菜单图标 */
  #header .header-nav-m .header-nav-m-menu-wrapper {
    position: absolute;
    top: 50%;
    right: 20px;
    margin-top: -20px;
    width: 50px;
    height: 40px;
    color: #fff;
    z-index: 999999;
    font-size: 12px;
  }
  /* 导航栏 */
  #header .header-nav-m .header-nav-m-wrapper {
    position: absolute;
    top: 50px;
    left: 0;
    width: 100%;
    background: linear-gradient(90deg, #41b6e6 0%, #0076ce 100%);
    z-index: 9999999;
  }
  /* 导航栏 每个导航 */
  #header .header-nav-m .header-nav-m-wrapper > li {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #ccc;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav-m .header-nav-m-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 15px;
    position: relative;
  }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 10px;
  }
  .search {
    position: absolute;
    top: 50%;
    left: 5%;
    transform: translateY(-50%);
  }
}
@media screen and (min-width: 996px) and (max-width: 1200px) {
  #header .header-nav .header-nav-wrapper {
    line-height: 10px;
    float: right;
    margin: 0;
    max-width: 1000px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper > li > a {
    color: #fff;
    font-size: 15px;
    font-weight: bold;
    padding: 10px 0px;
    position: relative;
  }
}
.navbar {
  margin-bottom: 0 !important;
}
.navbar-default {
  background: linear-gradient(90deg, #41b6e6 0%, #0076ce 100%) !important;
}
.dropdown-toggle {
  color: #fff !important;
}
.dropdown-toggle:hover {
  background-color: #41b6e6;
}
.navbar-brand {
  color: #fff !important;
}
.navbar-default .navbar-toggle {
  border-color: #fff;
}
.navbar-default .navbar-toggle:focus,
.navbar-default .navbar-toggle:hover {
  background-color: #fff;
}
.navbar-default .navbar-toggle .icon-bar {
  background-color: #41b6e6;
}
.navbar-default .navbar-nav > .open > a,
.navbar-default .navbar-nav > .open > a:focus,
.navbar-default .navbar-nav > .open > a:hover {
  background-color: #60c5ec;
}
.nav > li {
  border-bottom: 1px solid #fff;
}
.navbar-form {
  border-top: 0;
  border-bottom: 0;
  -webkit-box-shadow: 0;
  box-shadow: 0;
}
.dropdown-menu {
  background: linear-gradient(90deg, #41b6e6 0%, #0076ce 100%) !important;
}
@media screen and (min-width: 768px) and (max-width: 1024px) {
  .navbar > .container .navbar-brand,
  .navbar > .container-fluid .navbar-brand {
    margin-left: 0;
  }
}

.title-algin {
  margin-top: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue